
import Vue from 'vue'

const locales = {keys(){return []}}
global['____BAB6F73____'] = true;
delete global['____BAB6F73____'];
global.__uniConfig = {"globalStyle":{"navigationBarTextStyle":"black","navigationBarTitleText":"","navigationBarBackgroundColor":"#FFFFFF","backgroundColorTop":"#FFFFFF","backgroundColor":"#FFFFFF","backgroundColorBottom":"#FFFFFF","titleNView":false},"easycom":{"autoscan":true,"custom":{"^html2canvas$":"html2canvas/dist/html2canvas.esm.js","^unicloud-db$":"@dcloudio/uni-cli-shared/components/unicloud-db.vue","^uniad$":"@dcloudio/uni-cli-shared/components/uniad.vue","^ad-rewarded-video$":"@dcloudio/uni-cli-shared/components/ad-rewarded-video.vue","^ad-fullscreen-video$":"@dcloudio/uni-cli-shared/components/ad-fullscreen-video.vue","^ad-interstitial$":"@dcloudio/uni-cli-shared/components/ad-interstitial.vue","^ad-interactive$":"@dcloudio/uni-cli-shared/components/ad-interactive.vue","^page-meta$":"@dcloudio/uni-cli-shared/components/page-meta.vue","^navigation-bar$":"@dcloudio/uni-cli-shared/components/navigation-bar.vue","^uni-match-media$":"@dcloudio/uni-cli-shared/components/uni-match-media.vue"}}};
global.__uniConfig.compilerVersion = '5.07';
global.__uniConfig.darkmode = false;
global.__uniConfig.themeConfig = {};
global.__uniConfig.uniPlatform = 'h5';
global.__uniConfig.appId = '__UNI__BAB6F73';
global.__uniConfig.appName = 'COG可信资产服务平台';
global.__uniConfig.appVersion = '1.0.0';
global.__uniConfig.appVersionCode = '100';
global.__uniConfig.router = {"mode":"history","base":"/"};
global.__uniConfig.publicPath = "/";
global.__uniConfig['async'] = {"loading":"AsyncLoading","error":"AsyncError","delay":200,"timeout":60000};
global.__uniConfig.debug = false;
global.__uniConfig.networkTimeout = {"request":60000,"connectSocket":60000,"uploadFile":60000,"downloadFile":60000};
global.__uniConfig.sdkConfigs = {"maps":{"qqmap":{"key":"3RMBZ-5TMCI-JWJGX-52E4I-EALLO-TPB66"}}};
global.__uniConfig.qqMapKey = "3RMBZ-5TMCI-JWJGX-52E4I-EALLO-TPB66";
global.__uniConfig.googleMapKey = undefined;
global.__uniConfig.aMapKey = undefined;
global.__uniConfig.aMapSecurityJsCode = undefined;
global.__uniConfig.aMapServiceHost = undefined;
global.__uniConfig.locale = "";
global.__uniConfig.fallbackLocale = undefined;
global.__uniConfig.locales = locales.keys().reduce((res,key)=>{const locale=key.replace(/\.\/(uni-app.)?(.*).json/,'$2');const messages = locales(key);Object.assign(res[locale]||(res[locale]={}),messages.common||messages);return res},{});
global.__uniConfig.nvue = {"flex-direction":"column"}
global.__uniConfig.__webpack_chunk_load__ = __webpack_chunk_load__
Vue.component('pages-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/app/Goodgame/Goodgame/pages/index"+'.vue')), 'pages-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-game', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/app/Goodgame/Goodgame/pages/game"+'.vue')), 'pages-game'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-invest', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/app/Goodgame/Goodgame/pages/invest"+'.vue')), 'pages-invest'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-expert', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/app/Goodgame/Goodgame/pages/expert"+'.vue')), 'pages-expert'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-companyProflie', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/app/Goodgame/Goodgame/pages/companyProflie"+'.vue')), 'pages-companyProflie'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-news', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/app/Goodgame/Goodgame/pages/news"+'.vue')), 'pages-news'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-gameDtail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/app/Goodgame/Goodgame/pages/gameDtail"+'.vue')), 'pages-gameDtail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-publish', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/app/Goodgame/Goodgame/pages/publish"+'.vue')), 'pages-publish'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-blockchainquery', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/app/Goodgame/Goodgame/pages/blockchainquery"+'.vue')), 'pages-blockchainquery'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-oversea', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/app/Goodgame/Goodgame/pages/oversea"+'.vue')), 'pages-oversea'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-apply', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/app/Goodgame/Goodgame/pages/apply"+'.vue')), 'pages-apply'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-copyright', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/app/Goodgame/Goodgame/pages/copyright"+'.vue')), 'pages-copyright'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-versionNumber', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/app/Goodgame/Goodgame/pages/versionNumber"+'.vue')), 'pages-versionNumber'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-development', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/app/Goodgame/Goodgame/pages/development"+'.vue')), 'pages-development'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-expo', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/app/Goodgame/Goodgame/pages/expo"+'.vue')), 'pages-expo'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-subsidy', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/app/Goodgame/Goodgame/pages/subsidy"+'.vue')), 'pages-subsidy'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-register', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/app/Goodgame/Goodgame/pages/register"+'.vue')), 'pages-register'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-login', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/app/Goodgame/Goodgame/pages/login"+'.vue')), 'pages-login'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-forget', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/app/Goodgame/Goodgame/pages/forget"+'.vue')), 'pages-forget'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-member', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/app/Goodgame/Goodgame/pages/member"+'.vue')), 'pages-member'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-asset_list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/app/Goodgame/Goodgame/pages/asset_list"+'.vue')), 'pages-asset_list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-asset_add', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/app/Goodgame/Goodgame/pages/asset_add"+'.vue')), 'pages-asset_add'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-digital_assets', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/app/Goodgame/Goodgame/pages/digital_assets"+'.vue')), 'pages-digital_assets'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-digital_assets_add', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/app/Goodgame/Goodgame/pages/digital_assets_add"+'.vue')), 'pages-digital_assets_add'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-pay_list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/app/Goodgame/Goodgame/pages/pay_list"+'.vue')), 'pages-pay_list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-pay_detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/app/Goodgame/Goodgame/pages/pay_detail"+'.vue')), 'pages-pay_detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-notice_list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/app/Goodgame/Goodgame/pages/notice_list"+'.vue')), 'pages-notice_list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-notice_details', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/app/Goodgame/Goodgame/pages/notice_details"+'.vue')), 'pages-notice_details'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-asset', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/app/Goodgame/Goodgame/pages/asset"+'.vue')), 'pages-asset'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-articleDetails', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/app/Goodgame/Goodgame/pages/articleDetails"+'.vue')), 'pages-articleDetails'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-actDetails', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/app/Goodgame/Goodgame/pages/actDetails"+'.vue')), 'pages-actDetails'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
global.__uniRoutes=[
{
path: '/',
alias:'/pages/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isEntry:true,

          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"COG可信资产服务平台-一站式游戏出版、发行、投融资"})
      },
      [
        createElement('pages-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:1,
  name:'pages-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/index',
isQuit:true,
isEntry:true,
  windowTop:0
}
},
{
path: '/pages/game',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"资产中心","enablePullDownRefresh":true,"onReachBottomDistance":50})
      },
      [
        createElement('pages-game', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-game',
  isNVue:false,maxWidth:0,
  pagePath:'pages/game',
  windowTop:0
}
},
{
path: '/pages/invest',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我要资金"})
      },
      [
        createElement('pages-invest', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-invest',
  isNVue:false,maxWidth:0,
  pagePath:'pages/invest',
  windowTop:0
}
},
{
path: '/pages/expert',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"专家库"})
      },
      [
        createElement('pages-expert', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-expert',
  isNVue:false,maxWidth:0,
  pagePath:'pages/expert',
  windowTop:0
}
},
{
path: '/pages/companyProflie',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"平台简介"})
      },
      [
        createElement('pages-companyProflie', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-companyProflie',
  isNVue:false,maxWidth:0,
  pagePath:'pages/companyProflie',
  windowTop:0
}
},
{
path: '/pages/news',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"关于我们"})
      },
      [
        createElement('pages-news', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-news',
  isNVue:false,maxWidth:0,
  pagePath:'pages/news',
  windowTop:0
}
},
{
path: '/pages/gameDtail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"游戏详情"})
      },
      [
        createElement('pages-gameDtail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-gameDtail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/gameDtail',
  windowTop:0
}
},
{
path: '/pages/publish',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我要发行"})
      },
      [
        createElement('pages-publish', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-publish',
  isNVue:false,maxWidth:0,
  pagePath:'pages/publish',
  windowTop:0
}
},
{
path: '/pages/blockchainquery',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"区块链数字资产查询"})
      },
      [
        createElement('pages-blockchainquery', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-blockchainquery',
  isNVue:false,maxWidth:0,
  pagePath:'pages/blockchainquery',
  windowTop:0
}
},
{
path: '/pages/oversea',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我要出海"})
      },
      [
        createElement('pages-oversea', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-oversea',
  isNVue:false,maxWidth:0,
  pagePath:'pages/oversea',
  windowTop:0
}
},
{
path: '/pages/apply',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我要申请"})
      },
      [
        createElement('pages-apply', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-apply',
  isNVue:false,maxWidth:0,
  pagePath:'pages/apply',
  windowTop:0
}
},
{
path: '/pages/copyright',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我要版权"})
      },
      [
        createElement('pages-copyright', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-copyright',
  isNVue:false,maxWidth:0,
  pagePath:'pages/copyright',
  windowTop:0
}
},
{
path: '/pages/versionNumber',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我要版号"})
      },
      [
        createElement('pages-versionNumber', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-versionNumber',
  isNVue:false,maxWidth:0,
  pagePath:'pages/versionNumber',
  windowTop:0
}
},
{
path: '/pages/development',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我要技术"})
      },
      [
        createElement('pages-development', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-development',
  isNVue:false,maxWidth:0,
  pagePath:'pages/development',
  windowTop:0
}
},
{
path: '/pages/expo',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我要参展"})
      },
      [
        createElement('pages-expo', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-expo',
  isNVue:false,maxWidth:0,
  pagePath:'pages/expo',
  windowTop:0
}
},
{
path: '/pages/subsidy',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我要补贴"})
      },
      [
        createElement('pages-subsidy', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-subsidy',
  isNVue:false,maxWidth:0,
  pagePath:'pages/subsidy',
  windowTop:0
}
},
{
path: '/pages/register',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"注册"})
      },
      [
        createElement('pages-register', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-register',
  isNVue:false,maxWidth:0,
  pagePath:'pages/register',
  windowTop:0
}
},
{
path: '/pages/login',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"登录"})
      },
      [
        createElement('pages-login', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-login',
  isNVue:false,maxWidth:0,
  pagePath:'pages/login',
  windowTop:0
}
},
{
path: '/pages/forget',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"忘记密码"})
      },
      [
        createElement('pages-forget', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-forget',
  isNVue:false,maxWidth:0,
  pagePath:'pages/forget',
  windowTop:0
}
},
{
path: '/pages/member',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"个人中心"})
      },
      [
        createElement('pages-member', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-member',
  isNVue:false,maxWidth:0,
  pagePath:'pages/member',
  windowTop:0
}
},
{
path: '/pages/asset_list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"资产列表"})
      },
      [
        createElement('pages-asset_list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-asset_list',
  isNVue:false,maxWidth:0,
  pagePath:'pages/asset_list',
  windowTop:0
}
},
{
path: '/pages/asset_add',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"资产新增"})
      },
      [
        createElement('pages-asset_add', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-asset_add',
  isNVue:false,maxWidth:0,
  pagePath:'pages/asset_add',
  windowTop:0
}
},
{
path: '/pages/digital_assets',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"资产列表"})
      },
      [
        createElement('pages-digital_assets', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-digital_assets',
  isNVue:false,maxWidth:0,
  pagePath:'pages/digital_assets',
  windowTop:0
}
},
{
path: '/pages/digital_assets_add',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"资产新增"})
      },
      [
        createElement('pages-digital_assets_add', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-digital_assets_add',
  isNVue:false,maxWidth:0,
  pagePath:'pages/digital_assets_add',
  windowTop:0
}
},
{
path: '/pages/pay_list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"付款记录"})
      },
      [
        createElement('pages-pay_list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-pay_list',
  isNVue:false,maxWidth:0,
  pagePath:'pages/pay_list',
  windowTop:0
}
},
{
path: '/pages/pay_detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"付款详情"})
      },
      [
        createElement('pages-pay_detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-pay_detail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/pay_detail',
  windowTop:0
}
},
{
path: '/pages/notice_list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"平台通知"})
      },
      [
        createElement('pages-notice_list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-notice_list',
  isNVue:false,maxWidth:0,
  pagePath:'pages/notice_list',
  windowTop:0
}
},
{
path: '/pages/notice_details',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"平台通知详情"})
      },
      [
        createElement('pages-notice_details', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-notice_details',
  isNVue:false,maxWidth:0,
  pagePath:'pages/notice_details',
  windowTop:0
}
},
{
path: '/pages/asset',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"数字资产确权存证"})
      },
      [
        createElement('pages-asset', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-asset',
  isNVue:false,maxWidth:0,
  pagePath:'pages/asset',
  windowTop:0
}
},
{
path: '/pages/articleDetails',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"新闻详情"})
      },
      [
        createElement('pages-articleDetails', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-articleDetails',
  isNVue:false,maxWidth:0,
  pagePath:'pages/articleDetails',
  windowTop:0
}
},
{
path: '/pages/actDetails',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"活动详情"})
      },
      [
        createElement('pages-actDetails', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-actDetails',
  isNVue:false,maxWidth:0,
  pagePath:'pages/actDetails',
  windowTop:0
}
},
{
path: '/choose-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-choose-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'choose-location',
  pagePath:'/choose-location'
}
}
    ,
{
path: '/open-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-open-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'open-location',
  pagePath:'/open-location'
}
}
    ]
global.UniApp && new global.UniApp();
